import './HiveCanvasLayout.css';
export var canvasContainer = '_12htcxh0-3-5-0';